import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  Nav,
  Button,
  Container,
  Navbar,
  NavDropdown,
  Offcanvas,
} from "react-bootstrap";
import { getSieUrls } from "../ApiAction/api"

export default function MyFooter(props) {
  const [url,setUrl] = useState({})

  async function getSocialUrls() {
    try {
      let {status, result } = await getSieUrls();
     if(status){
      setUrl(result)
     }else{
      return false
     }
    } catch (err) {
      console.log(err,"errr");
    }
  }

  useEffect(() =>{
    getSocialUrls()
  },[])
  return (
    <>
      <footer>
        <Container>
          <div className="footer_head">
            <div>
              <div className="logo_img_1">
                <img
                  src={require("../assets/images/logo.png")}
                  alt="icon"
                  className="img-fluid logo_img"
                />
              </div>
              <p>
                Donec suscipit eget erat quis blandit. Vivamus tristique
                ultricies lectus, eget egestas nisi pharetra dapibus.
              </p>
              <ul className="soical_icons_head">
                <li class="icon-content">
                  <a href={`${url?.twitter}`} target = "blank">
                    <img
                      src={require("../assets/images/social_icon1.png")}
                      alt="icon"
                      className="img-fluid"
               
                    />
                  </a>
                </li>
                <li class="icon-content">
                  <a href={`${url?.facebook}`} target = "blank">
                    <img
                      src={require("../assets/images/social_icon2.png")}
                      alt="icon"
                      className="img-fluid"
                    />
                  </a>
                </li>
                <li class="icon-content">
                  <a href={`${url?.instagram}`} target = "blank">
                    <img
                      src={require("../assets/images/social_icon3.png")}
                      alt="icon"
                      className="img-fluid"
                    />
                  </a>
                </li>
                <li class="icon-content">
                  <a href={`${url?.youtube}`} target = "blank">
                    <img
                      src={require("../assets/images/social_icon4.png")}
                      alt="icon"
                      className="img-fluid"
                    />
                  </a>
                </li>
                <li class="icon-content">
                  <a href={`${url?.whatsapp}`}  target = "blank">
                    <img
                      src={require("../assets/images/social_icon5.png")}
                      alt="icon"
                      className="img-fluid"
                    />
                  </a>
                </li>

                <li class="icon-content">
                  <a href={`${url?.telegram}`} target = "blank">
                    <img
                      src={require("../assets/images/social_icon7.png")}
                      alt="icon"
                      className="img-fluid"
                    />
                  </a>
                </li>
              </ul>
            </div>
            <div className="d-flex justify-content-between">
              <div>
                <h6>Useful Links</h6>
                <ul>
                  <li>
                    <Link to="#">Contact us</Link>
                  </li>
                  <li>
                    <Link to="#">How it Works</Link>
                  </li>
                  <li>
                    <Link to="#">Create</Link>
                  </li>
                  <li>
                    <Link to="#">Explore</Link>
                  </li>
                  <li>
                    <Link to="#">Terms & Services</Link>
                  </li>
                </ul>
              </div>
              <div>
                <h6>Company</h6>
                <div className="ul_list">
                  <ul>
                    <li>
                      <Link to="#">Help Center</Link>
                    </li>
                    <li>
                      <Link to="#">Partners</Link>
                    </li>
                    <li>
                      <Link to="#">Suggestions</Link>
                    </li>
                    <li>
                      <Link to="#">Blog</Link>
                    </li>
                    <li>
                      <Link to="#">Newsletters</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="footer_bottom">
            <p>Copyright © 2025. All Rights Reserved WAIQ</p>
            <div>
              <Link to="#">Terms and conditions </Link>
              <Link to="#">Privacy policy </Link>
            </div>
          </div>
        </Container>
      </footer>
    </>
  );
}
